import React from "react";
import ReactDOM from "react-dom/client";

// 2026-07-30 CHG-046 P2 hotfix — order-critical bootstrap.
// 1) Neutralize console.error for ResizeObserver-loop messages FIRST, because
//    react-error-overlay hooks console.error internally — the module wrapper
//    in silenceResizeObserver.js catches window.onerror but not console.error.
// 2) Then import silenceResizeObserver so its ResizeObserver-constructor wrap
//    lands before any component (Radix, chart libs) instantiates an observer.
// 3) Then everything else.
if (typeof window !== "undefined") {
    const _consoleError = window.console.error;
    window.console.error = (...args) => {
        const first = args[0];
        if (typeof first === "string" && first.includes("ResizeObserver loop")) return;
        if (first && typeof first.message === "string" && first.message.includes("ResizeObserver loop")) return;
        return _consoleError.apply(window.console, args);
    };
}

import "@/index.css";
import App from "@/App";
import installResizeObserverSilencer from "./lib/silenceResizeObserver";

// Filter the benign Radix ResizeObserver warning BEFORE CRA's dev-overlay
// treats it as fatal. Idempotent, install once at boot before ReactDOM.render.
// The module also self-installs on eval — this call is belt-and-suspenders.
installResizeObserverSilencer();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
